import { createSlice, createEntityAdapter } from '@reduxjs/toolkit'

const fileAdapter = createEntityAdapter({
    selectId: file => file.fileId,
})

export const fileSelector = fileAdapter.getSelectors(state => state.files)

const initialState = { ...fileAdapter.getInitialState(), loading: false }

const fileSlice = createSlice({
    name: 'files',
    initialState,
    reducers: {
        set: (state, payload) => {
            fileAdapter.setAll(state, payload)
        },
        remove: state => {
            fileAdapter.removeAll(state)
        },
    },
})

export const { set, remove } = fileSlice.actions

export default fileSlice.reducer
